webpackJsonp([5],{

/***/ 155:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.delOrder = exports.queryBook = exports.queryVideo = exports.generateNotarization = exports.getNotarization = exports.attachment = exports.getEnterFile = exports.setOrderEnter = exports.getCustomer = exports.fileUpload = exports.addContract = exports.orderNotary = exports.getOrderList = exports.updateProduct = exports.getProductDetail = exports.addProduct = exports.getProductList = exports.getProductCategory = exports.downloadContract = exports.queryContract = exports.createContract = exports.addSigner = exports.updateDeliveryUrl = exports.getContractList = exports.addEnterpriseUser = exports.changeMerchantStatus = exports.verifyMerchant = exports.sendVerify = exports.editMerchant = exports.addMerchant = exports.getMerchantListPage = exports.requestLogout = exports.changePassword = exports.requestLogin = undefined;

var _extends2 = __webpack_require__(102);

var _extends3 = _interopRequireDefault(_extends2);

var _request = __webpack_require__(283);

var _request2 = _interopRequireDefault(_request);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var requestLogin = exports.requestLogin = function requestLogin(data) {
    return (0, _request2.default)({
        url: '/user/admin/login',
        method: 'post',
        data: data
    });
};
var changePassword = exports.changePassword = function changePassword(data) {
    return (0, _request2.default)({
        url: '/user/changePassword',
        method: 'post',
        data: data
    });
};

var requestLogout = exports.requestLogout = function requestLogout() {
    return (0, _request2.default)({
        url: '/user/admin/logout',
        method: 'get'
    });
};
var getMerchantListPage = exports.getMerchantListPage = function getMerchantListPage(data) {
    return (0, _request2.default)({
        url: '/merchant/selectPage',
        method: 'post',
        data: data
    });
};

var addMerchant = exports.addMerchant = function addMerchant(data) {
    return (0, _request2.default)({
        url: '/merchant/insert',
        method: 'post',
        data: data
    });
};
var editMerchant = exports.editMerchant = function editMerchant(data) {
    return (0, _request2.default)({
        url: '/merchant/update',
        method: 'post',
        data: data
    });
};
var sendVerify = exports.sendVerify = function sendVerify(params) {
    return (0, _request2.default)({
        url: '/onlineSign/sendVerifyCode',
        method: 'get',
        params: params
    });
};
var verifyMerchant = exports.verifyMerchant = function verifyMerchant(data) {
    return (0, _request2.default)({
        url: '/merchant/onlineSign/verifyCode',
        method: 'post',
        data: data
    });
};
var changeMerchantStatus = exports.changeMerchantStatus = function changeMerchantStatus(data) {
    return (0, _request2.default)({
        url: '/user/admin/updateState',
        method: 'post',
        data: data
    });
};

var addEnterpriseUser = exports.addEnterpriseUser = function addEnterpriseUser(params) {
    return (0, _request2.default)({
        url: '/onlineSign/addEnterpriseUser',
        method: 'get',
        params: params
    });
};

var getContractList = exports.getContractList = function getContractList(data) {
    return (0, _request2.default)({
        url: '/contract/selectPage',
        method: 'post',
        data: data
    });
};

var updateDeliveryUrl = exports.updateDeliveryUrl = function updateDeliveryUrl(data) {
    return (0, _request2.default)({
        url: '/contract/updateDeliveryUrl',
        method: 'post',
        data: data
    });
};

var addSigner = exports.addSigner = function addSigner(params) {
    return (0, _request2.default)({
        url: '/onlineSign/addSigner',
        method: 'get',
        params: params
    });
};

var createContract = exports.createContract = function createContract(params) {
    return (0, _request2.default)({
        url: '/onlineSign/createContract',
        method: 'get',
        params: params
    });
};

var queryContract = exports.queryContract = function queryContract(params) {
    return (0, _request2.default)({
        url: '/onlineSign/query',
        method: 'get',
        params: params
    });
};

var downloadContract = exports.downloadContract = function downloadContract(params) {
    return (0, _request2.default)({
        url: '/onlineSign/download',
        method: 'get',
        params: params
    });
};

var getProductCategory = exports.getProductCategory = function getProductCategory(params) {
    return (0, _request2.default)({
        url: '/product/getProductCategory',
        method: 'get',
        params: params
    });
};

var getProductList = exports.getProductList = function getProductList(data) {
    return (0, _request2.default)({
        url: '/product/selectPage',
        method: 'post',
        data: data
    });
};

var addProduct = exports.addProduct = function addProduct(data) {
    return (0, _request2.default)({
        url: '/product/insert',
        method: 'post',
        data: data
    });
};

var getProductDetail = exports.getProductDetail = function getProductDetail(data) {
    return (0, _request2.default)({
        url: '/product/detail',
        method: 'post',
        data: data
    });
};

var updateProduct = exports.updateProduct = function updateProduct(data) {
    return (0, _request2.default)({
        url: '/product/update',
        method: 'post',
        data: data
    });
};

var getOrderList = exports.getOrderList = function getOrderList(data) {
    return (0, _request2.default)({
        url: '/order/selectPage',
        method: 'post',
        data: data
    });
};

var orderNotary = exports.orderNotary = function orderNotary(params) {
    return (0, _request2.default)({
        url: '/order/orderNotary',
        method: 'get',
        params: params
    });
};

var addContract = exports.addContract = function addContract(data) {
    return (0, _request2.default)({
        url: '/contract/insert',
        method: 'post',
        data: data
    });
};

var fileUpload = exports.fileUpload = function fileUpload(data, setter) {
    return (0, _request2.default)((0, _extends3.default)({
        url: '/oss/fileUpload',
        method: 'post',
        data: data
    }, setter));
};

var getCustomer = exports.getCustomer = function getCustomer(params) {
    return (0, _request2.default)({
        url: '/enterOrder/getCustomer',
        method: 'get',
        params: params
    });
};

var setOrderEnter = exports.setOrderEnter = function setOrderEnter(data) {
    return (0, _request2.default)({
        url: '/enterOrder/setOrderEnter',
        method: 'post',
        data: data
    });
};

var getEnterFile = exports.getEnterFile = function getEnterFile(params) {
    return (0, _request2.default)({
        url: '/enterFile/getEnterFile',
        method: 'get',
        params: params
    });
};

var attachment = exports.attachment = function attachment(data) {
    return (0, _request2.default)({
        url: '/enterFile/attachment',
        method: 'post',
        data: data
    });
};

var getNotarization = exports.getNotarization = function getNotarization(params) {
    return (0, _request2.default)({
        url: '/enterNotarization/getNotarization',
        method: 'get',
        params: params
    });
};
var generateNotarization = exports.generateNotarization = function generateNotarization(data) {
    return (0, _request2.default)({
        url: '/enterNotarization/generateNotarization',
        method: 'post',
        data: data
    });
};

var queryVideo = exports.queryVideo = function queryVideo(params) {
    return (0, _request2.default)({
        url: '/enterNotarization/queryVideo',
        method: 'get',
        params: params
    });
};

var queryBook = exports.queryBook = function queryBook(params) {
    return (0, _request2.default)({
        url: '/enterNotarization/queryBook',
        method: 'get',
        params: params
    });
};

var delOrder = exports.delOrder = function delOrder(params) {
    return (0, _request2.default)({
        url: '/contract/delOrder',
        method: 'get',
        params: params
    });
};

/***/ }),

/***/ 232:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Login = __webpack_require__(568);

var _Login2 = _interopRequireDefault(_Login);

var _ = __webpack_require__(566);

var _2 = _interopRequireDefault(_);

var _Home = __webpack_require__(567);

var _Home2 = _interopRequireDefault(_Home);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routes = [{
    path: '/login',
    component: _Login2.default,
    name: '',
    hidden: true,
    meta: {
        permission: [1, 2, 3]
    }
}, {
    path: '/404',
    component: _2.default,
    name: '',
    hidden: true,
    meta: {
        permission: [1, 2, 3]
    }
}, {
    path: '/',
    component: _Home2.default,
    name: '',
    iconCls: '',
    leaf: true,
    meta: {
        permission: [2, 3]
    },
    children: [{
        path: '/merchant',
        component: function component() {
            return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 578));
        },
        name: '商家管理',
        meta: {
            permission: [2, 3]
        }
    }]
}, {
    path: '/',
    component: _Home2.default,
    name: '',
    iconCls: '',
    leaf: true,
    meta: {
        permission: [1, 2, 3]
    },
    children: [{
        path: '/product',
        component: function component() {
            return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 580));
        },
        name: '商品管理',
        meta: {
            permission: [1, 2, 3]
        }
    }]
}, {
    path: '/',
    component: _Home2.default,
    name: '',
    iconCls: '',
    leaf: true,
    meta: {
        permission: [1, 2, 3]
    },
    children: [{
        path: '/order',
        component: function component() {
            return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 579));
        },
        name: '订单管理',
        meta: {
            permission: [1, 2, 3]
        }
    }]
}, {
    path: '/',
    component: _Home2.default,
    name: '',
    iconCls: '',
    leaf: true,
    meta: {
        permission: [1, 2, 3]
    },
    children: [{
        path: '/contract',
        component: function component() {
            return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 577));
        },
        name: '合同管理',
        meta: {
            permission: [1, 2, 3]
        }
    }]
}, {
    path: '*',
    hidden: true,
    redirect: {
        path: '/404'
    },
    meta: {
        permission: [1, 2, 3]
    }
}];

exports.default = routes;

/***/ }),

/***/ 233:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(11);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(154);

var _vuex2 = _interopRequireDefault(_vuex);

var _actions = __webpack_require__(285);

var actions = _interopRequireWildcard(_actions);

var _getters = __webpack_require__(286);

var getters = _interopRequireWildcard(_getters);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);

var state = {
    count: 10
};

var mutations = {
    INCREMENT: function INCREMENT(state) {
        state.count++;
    },
    DECREMENT: function DECREMENT(state) {
        state.count--;
    }
};

exports.default = new _vuex2.default.Store({
    actions: actions,
    getters: getters,
    state: state,
    mutations: mutations
});

/***/ }),

/***/ 235:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 236:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 237:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(554)

var Component = __webpack_require__(75)(
  /* script */
  __webpack_require__(280),
  /* template */
  __webpack_require__(571),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 279:
/***/ (function(module, exports) {

module.exports = {"_args":[["axios@0.21.4","/Users/fanjd/myself/vue-admin-master"]],"_from":"axios@0.21.4","_id":"axios@0.21.4","_inBundle":false,"_integrity":"sha512-ut5vewkiu8jjGBdqpM44XxjuCjq9LAKeHVmoVfHVzy8eHgxxq8SbAVQNovDA8mVi05kP0Ea/n/UzcSHcTJQfNg==","_location":"/axios","_phantomChildren":{},"_requested":{"type":"version","registry":true,"raw":"axios@0.21.4","name":"axios","escapedName":"axios","rawSpec":"0.21.4","saveSpec":null,"fetchSpec":"0.21.4"},"_requiredBy":["/"],"_resolved":"https://registry.npmmirror.com/axios/-/axios-0.21.4.tgz","_spec":"0.21.4","_where":"/Users/fanjd/myself/vue-admin-master","author":{"name":"Matt Zabriskie"},"browser":{"./lib/adapters/http.js":"./lib/adapters/xhr.js"},"bugs":{"url":"https://github.com/axios/axios/issues"},"bundlesize":[{"path":"./dist/axios.min.js","threshold":"5kB"}],"dependencies":{"follow-redirects":"^1.14.0"},"description":"Promise based HTTP client for the browser and node.js","devDependencies":{"coveralls":"^3.0.0","es6-promise":"^4.2.4","grunt":"^1.3.0","grunt-banner":"^0.6.0","grunt-cli":"^1.2.0","grunt-contrib-clean":"^1.1.0","grunt-contrib-watch":"^1.0.0","grunt-eslint":"^23.0.0","grunt-karma":"^4.0.0","grunt-mocha-test":"^0.13.3","grunt-ts":"^6.0.0-beta.19","grunt-webpack":"^4.0.2","istanbul-instrumenter-loader":"^1.0.0","jasmine-core":"^2.4.1","karma":"^6.3.2","karma-chrome-launcher":"^3.1.0","karma-firefox-launcher":"^2.1.0","karma-jasmine":"^1.1.1","karma-jasmine-ajax":"^0.1.13","karma-safari-launcher":"^1.0.0","karma-sauce-launcher":"^4.3.6","karma-sinon":"^1.0.5","karma-sourcemap-loader":"^0.3.8","karma-webpack":"^4.0.2","load-grunt-tasks":"^3.5.2","minimist":"^1.2.0","mocha":"^8.2.1","sinon":"^4.5.0","terser-webpack-plugin":"^4.2.3","typescript":"^4.0.5","url-search-params":"^0.10.0","webpack":"^4.44.2","webpack-dev-server":"^3.11.0"},"homepage":"https://axios-http.com","jsdelivr":"dist/axios.min.js","keywords":["xhr","http","ajax","promise","node"],"license":"MIT","main":"index.js","name":"axios","repository":{"type":"git","url":"git+https://github.com/axios/axios.git"},"scripts":{"build":"NODE_ENV=production grunt build","coveralls":"cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js","examples":"node ./examples/server.js","fix":"eslint --fix lib/**/*.js","postversion":"git push && git push --tags","preversion":"npm test","start":"node ./sandbox/server.js","test":"grunt test","version":"npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json"},"typings":"./index.d.ts","unpkg":"dist/axios.min.js","version":"0.21.4"}

/***/ }),

/***/ 280:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	name: 'app',
	components: {}
};

/***/ }),

/***/ 281:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _regenerator = __webpack_require__(292);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(291);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _api = __webpack_require__(155);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	data: function data() {
		var _this2 = this;

		var validatePass = function validatePass(rule, value, callback) {
			var pass = /^(?=.*?[a-z)(?=.*>[A-Z])(?=.*?[0-9])[a-zA_Z0-9]{8,10}$/gi;
			if (!pass.test(value)) {
				callback(new Error("请输入8-10位英文和数字组成的密码"));
			} else {
				if (_this2.form.checkPassword !== "") {
					_this2.$refs.form.validateField("checkPassword");
				}
				callback();
			}
		};
		var validatePass2 = function validatePass2(rule, value, callback) {
			if (value === "") {
				callback(new Error("请再次输入新密码"));
			} else if (value !== _this2.passWordForm.password) {
				callback(new Error("两次输入密码不一致!"));
			} else {
				callback();
			}
		};
		return {
			sysName: '吉麟珠宝',
			collapsed: false,
			sysUserName: '',
			sysUserAvatar: '',
			dialogEdit: false,
			form: {
				name: '',
				region: '',
				date1: '',
				date2: '',
				delivery: false,
				type: [],
				resource: '',
				desc: ''
			},
			passWordForm: {
				originalpassword: "",
				password: "",
				checkPassword: "" },
			rule: {
				originalpassword: [{ required: true, message: "请输入原始密码", trigger: "blur" }],
				password: [{ required: true, message: "请输入新密码", trigger: "blur" }, { validator: validatePass, trigger: "blur" }],
				checkPassword: [{ required: true, message: "请再次输入新密码", trigger: "blur" }, { validator: validatePass2, trigger: "blur" }]
			}
		};
	},

	computed: {
		routerList: function routerList() {
			var list = this.$router.options.routes;
			var user = localStorage.getItem('user');
			var role = '';
			if (user) {
				user = JSON.parse(user);
				role = user.role;
			}
			var routes = permissionRouter();
			function permissionRouter() {
				var router = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : list;

				return router.filter(function (item) {
					if (item.children) {
						item.children = permissionRouter(item.children);
					}
					return item.meta.permission.includes(role);
				});
			}
			return routes;
		}
	},
	methods: {
		changePassWord: function changePassWord() {
			console.log("修改密码");
			this.dialogEdit = true;
			this.title = "修改密码";
			this.form = {
				originalpassword: "",
				password: "",
				checkPassword: "" };
		},
		onSubmit: function onSubmit() {
			console.log('submit!');
		},
		handleopen: function handleopen() {},
		handleclose: function handleclose() {},

		handleselect: function handleselect(a, b) {},

		logout: function logout() {
			var _this = this;
			this.$confirm('确认退出吗?', '提示', {}).then(function () {

				(0, _api.requestLogout)().then(function (res) {
					console.log('退登', res);
					localStorage.clear();
					_this.$router.push('/login');
				});
			}).catch(function () {});
		},
		submitForm: function submitForm(formName) {
			var _this3 = this;

			this.$refs[formName].validate(function () {
				var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(valid) {
					var para;
					return _regenerator2.default.wrap(function _callee$(_context) {
						while (1) {
							switch (_context.prev = _context.next) {
								case 0:
									if (valid) {
										para = { newPassword: _this3.passWordForm.password, oldPassword: _this3.passWordForm.originalpassword };

										(0, _api.changePassword)(para).then(function (res) {
											console.log('修改密码', res);
											if (res.data.code == 10000) {
												_this3.$message.success("修改成功！");
												_this3.dialogEdit = false;
											} else {
												_this3.$message.error(res.msg);
											}
										}).catch(function () {
											_this3.$message.error(res.msg);
										});
									}

								case 1:
								case "end":
									return _context.stop();
							}
						}
					}, _callee, _this3);
				}));

				return function (_x2) {
					return _ref.apply(this, arguments);
				};
			}());
		},
		resetForm: function resetForm(formName) {
			this.dialogEdit = false;
			this.$refs[formName].resetFields();
		},

		collapse: function collapse() {
			this.collapsed = !this.collapsed;
		},
		showMenu: function showMenu(i, status) {
			this.$refs.menuCollapsed.getElementsByClassName('submenu-hook-' + i)[0].style.display = status ? 'block' : 'none';
		}
	},
	mounted: function mounted() {
		var user = localStorage.getItem('user');
		if (user) {
			user = JSON.parse(user);
			this.sysUserName = user.merchantName || '管理员';
		}
	}
};

/***/ }),

/***/ 282:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(288);

var _stringify2 = _interopRequireDefault(_stringify);

var _axios = __webpack_require__(157);

var _axios2 = _interopRequireDefault(_axios);

var _api = __webpack_require__(155);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      logining: false,
      ruleForm2: {
        account: '',
        checkPass: ''
      },
      rules2: {
        account: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        checkPass: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      },
      checked: true
    };
  },

  methods: {
    handleReset2: function handleReset2() {
      this.$refs.ruleForm2.resetFields();
    },
    handleSubmit2: function handleSubmit2(ev) {
      var _this = this;
      _this.$refs.ruleForm2.validate(function (valid) {
        if (valid) {
          _this.logining = true;

          var loginParams = { userName: _this.ruleForm2.account, userPwd: _this.ruleForm2.checkPass };
          (0, _api.requestLogin)(loginParams).then(function (res) {
            _this.logining = false;
            console.log('登录', res);
            var token = res.token,
                userId = res.userId,
                merchantId = res.merchantId,
                merchantName = res.merchantName,
                role = res.role;

            var user = {
              userId: userId, merchantId: merchantId, merchantName: merchantName, role: role
            };

            localStorage.setItem('token', token);
            localStorage.setItem('user', (0, _stringify2.default)(user));
            if (role == 1) {
              _this.$router.push({ path: '/product' });
            } else {
              _this.$router.push({ path: '/merchant' });
            }
          }).catch(function (res) {
            _this.logining = false;
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  }
};

/***/ }),

/***/ 283:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promise = __webpack_require__(167);

var _promise2 = _interopRequireDefault(_promise);

var _axios = __webpack_require__(157);

var _axios2 = _interopRequireDefault(_axios);

var _elementUi = __webpack_require__(153);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var service = _axios2.default.create({
    baseURL: '/llg',

    timeout: 30000 });

service.interceptors.request.use(function (config) {
    if (localStorage.getItem('token') != undefined) {
        config.headers['token'] = localStorage.getItem('token');
    }
    return config;
}, function (error) {
    console.log(error);
    return _promise2.default.reject(error);
});

service.interceptors.response.use(function (response) {
    var res = response.data;
    console.log(res);

    if (res.code != 10000) {
        (0, _elementUi.Message)({
            message: res.msg || 'Error',
            type: 'error',
            duration: 5 * 1000
        });

        if (res.code == 20001) {
            _elementUi.MessageBox.confirm('登录状态过期，请重新登录！', '请重新登录', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {
                var headers = {
                    token: localStorage.getItem('token')
                };
                _axios2.default.get('/llg/user/admin/logout/', {
                    headers: headers
                }).then(function (res) {
                    console.log('退登', res);
                    localStorage.clear();
                    window.location.reload();
                }).catch(function (err) {
                    console.log('退登出错', err);
                });
            });
        }
        return _promise2.default.reject(new Error(res.msg || 'Error'));
    } else {
        return res.data;
    }
}, function (error) {
    console.log('err' + error);
    var msg = error.message;
    if (msg == "Network Error") {
        msg = "看到这个提示请尝试如下操作：1.当前无网络，请检查网络 2.系统正在维护，请晚些再试";
    } else if (msg.indexOf("timeout") > -1) {
        msg = "连接超时，请深吸一口气，重试一下";
    } else {
        msg = "请求错误";
    }
    (0, _elementUi.Message)({
        message: msg,
        type: 'error',
        duration: 5 * 1000
    });
    return _promise2.default.reject(error);
});

exports.default = service;

/***/ }),

/***/ 284:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _babelPolyfill = __webpack_require__(234);

var _babelPolyfill2 = _interopRequireDefault(_babelPolyfill);

var _vue = __webpack_require__(11);

var _vue2 = _interopRequireDefault(_vue);

var _App = __webpack_require__(237);

var _App2 = _interopRequireDefault(_App);

var _elementUi = __webpack_require__(153);

var _elementUi2 = _interopRequireDefault(_elementUi);

__webpack_require__(235);

var _vueRouter = __webpack_require__(238);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _store = __webpack_require__(233);

var _store2 = _interopRequireDefault(_store);

var _vuex = __webpack_require__(154);

var _vuex2 = _interopRequireDefault(_vuex);

var _routes = __webpack_require__(232);

var _routes2 = _interopRequireDefault(_routes);

__webpack_require__(236);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_elementUi2.default, {
  size: 'small',
  zIndex: 3000
});
_vue2.default.use(_vueRouter2.default);
_vue2.default.use(_vuex2.default);

var router = new _vueRouter2.default({
  mode: 'history',
  routes: _routes2.default
});

router.beforeEach(function (to, from, next) {
  if (to.path == '/login') {
    localStorage.clear();
  }
  var user = JSON.parse(localStorage.getItem('user'));
  if (!user && to.path != '/login') {
    next({
      path: '/login'
    });
  } else {

    if (to.path == '/') {
      var url = user.role == 1 ? '/product' : '/merchant';
      next({
        path: url
      });
    } else {
      next();
    }
  }
});

new _vue2.default({
  router: router,
  store: _store2.default,

  render: function render(h) {
    return h(_App2.default);
  }
}).$mount('#app');

/***/ }),

/***/ 285:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var increment = exports.increment = function increment(_ref) {
    var commit = _ref.commit;

    commit('INCREMENT');
};
var decrement = exports.decrement = function decrement(_ref2) {
    var commit = _ref2.commit;

    commit('DECREMENT');
};

/***/ }),

/***/ 286:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var getCount = exports.getCount = function getCount(state) {
    return state.count;
};

/***/ }),

/***/ 552:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 553:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 554:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 555:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 566:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(555)

var Component = __webpack_require__(75)(
  /* script */
  null,
  /* template */
  __webpack_require__(572),
  /* scopeId */
  "data-v-9cdc7cca",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 567:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(552)

var Component = __webpack_require__(75)(
  /* script */
  __webpack_require__(281),
  /* template */
  __webpack_require__(569),
  /* scopeId */
  "data-v-07111bac",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 568:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(553)

var Component = __webpack_require__(75)(
  /* script */
  __webpack_require__(282),
  /* template */
  __webpack_require__(570),
  /* scopeId */
  "data-v-0e117f28",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 569:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "container"
  }, [_c('el-col', {
    staticClass: "header",
    attrs: {
      "span": 24
    }
  }, [_c('el-col', {
    staticClass: "logo",
    class: _vm.collapsed ? 'logo-collapse-width' : 'logo-width',
    attrs: {
      "span": 10
    }
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.collapsed ? '' : _vm.sysName) + "\n\t\t")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('div', {
    staticClass: "tools",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.collapse.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-align-justify"
  })])]), _vm._v(" "), _c('el-col', {
    staticClass: "userinfo",
    attrs: {
      "span": 4
    }
  }, [_c('el-dropdown', {
    attrs: {
      "trigger": "hover"
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link userinfo-inner"
  }, [_vm._v(_vm._s(_vm.sysUserName))]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    attrs: {
      "divided": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.logout.apply(null, arguments)
      }
    }
  }, [_vm._v("退出登录")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "修改密码",
      "visible": _vm.dialogEdit,
      "append-to-body": true,
      "width": "30%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogEdit = $event
      }
    }
  }, [_c('el-form', {
    ref: "passWordForm",
    attrs: {
      "model": _vm.passWordForm,
      "rules": _vm.rule
    }
  }, [_c('el-form-item', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "原始密码:",
      "prop": "originalpassword",
      "label-width": "110px"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.passWordForm.originalpassword),
      callback: function($$v) {
        _vm.$set(_vm.passWordForm, "originalpassword", $$v)
      },
      expression: "passWordForm.originalpassword"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "新密码:",
      "prop": "password",
      "label-width": "110px"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": "10",
      "minlength": "3"
    },
    model: {
      value: (_vm.passWordForm.password),
      callback: function($$v) {
        _vm.$set(_vm.passWordForm, "password", $$v)
      },
      expression: "passWordForm.password"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "确认新密码:",
      "prop": "checkPassword",
      "label-width": "110px"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": "10",
      "minlength": "3"
    },
    model: {
      value: (_vm.passWordForm.checkPassword),
      callback: function($$v) {
        _vm.$set(_vm.passWordForm, "checkPassword", $$v)
      },
      expression: "passWordForm.checkPassword"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        return _vm.resetForm('passWordForm')
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('passWordForm')
      }
    }
  }, [_vm._v("提交")])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "main",
    attrs: {
      "span": 24
    }
  }, [_c('aside', [_c('el-menu', {
    staticClass: "el-menu-vertical-demo",
    attrs: {
      "default-active": _vm.$route.path,
      "unique-opened": "",
      "router": "",
      "collapse": _vm.collapsed
    },
    on: {
      "open": _vm.handleopen,
      "close": _vm.handleclose,
      "select": _vm.handleselect
    }
  }, [_vm._l((_vm.routerList), function(item, index) {
    return [(!item.hidden) ? [(!item.leaf) ? _c('el-submenu', {
      key: index,
      attrs: {
        "index": index + ''
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('i', {
      class: item.iconCls
    }), _c('span', {
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_vm._v(_vm._s(item.name))])]), _vm._v(" "), _vm._l((item.children), function(child) {
      return _c('el-menu-item', {
        key: child.path,
        attrs: {
          "index": child.path
        }
      }, [(!child.hidden) ? _c('span', [_vm._v(_vm._s(child.name))]) : _vm._e()])
    })], 2) : _vm._e(), _vm._v(" "), (item.leaf && item.children.length > 0) ? _c('el-menu-item', {
      key: index,
      attrs: {
        "index": item.children[0].path
      }
    }, [_c('i', {
      class: item.iconCls
    }), _c('span', {
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_vm._v(_vm._s(item.children[0].name))])]) : _vm._e()] : _vm._e()]
  })], 2)], 1), _vm._v(" "), _c('section', {
    staticClass: "content-container"
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light"
  }, [_c('el-col', {
    staticClass: "breadcrumb-container",
    attrs: {
      "span": 24
    }
  }, [_c('strong', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$route.name))]), _vm._v(" "), _c('el-breadcrumb', {
    staticClass: "breadcrumb-inner",
    attrs: {
      "separator": "/"
    }
  }, _vm._l((_vm.$route.matched), function(item) {
    return _c('el-breadcrumb-item', {
      key: item.path
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(item.name) + "\n\t\t\t\t\t\t")])
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "content-wrapper",
    attrs: {
      "span": 24
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)], 1)])]), _vm._v(" "), _c('el-col', {
    staticClass: "footer",
    attrs: {
      "span": 24
    }
  }, [_vm._v("\n\t\t吉林市昌邑区吉麟珠宝店 Copyright © 2026 "), _c('a', {
    attrs: {
      "href": "https://beian.miit.gov.cn",
      "target": "_blank"
    }
  }, [_vm._v("吉ICP备2026000884号")])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 570:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "ruleForm2",
    staticClass: "demo-ruleForm login-container",
    attrs: {
      "model": _vm.ruleForm2,
      "rules": _vm.rules2,
      "label-position": "left",
      "label-width": "0px"
    }
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("系统登录")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "account"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "账号"
    },
    model: {
      value: (_vm.ruleForm2.account),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm2, "account", $$v)
      },
      expression: "ruleForm2.account"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "checkPass"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off",
      "placeholder": "密码"
    },
    model: {
      value: (_vm.ruleForm2.checkPass),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm2, "checkPass", $$v)
      },
      expression: "ruleForm2.checkPass"
    }
  })], 1), _vm._v(" "), _c('el-checkbox', {
    staticClass: "remember",
    attrs: {
      "checked": ""
    },
    model: {
      value: (_vm.checked),
      callback: function($$v) {
        _vm.checked = $$v
      },
      expression: "checked"
    }
  }, [_vm._v("记住密码")]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.logining
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.handleSubmit2.apply(null, arguments)
      }
    }
  }, [_vm._v("登录")])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 571:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 572:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "page-container"
  }, [_vm._v("404 page not found")])
},staticRenderFns: []}

/***/ })

},[284]);


// WEBPACK FOOTER //
// static/js/app.72de5ef5e4c6c25838fe.js